import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/share';

export class CuiScrollContainer {
  static localScrollPosition = 'scrollPosition';
  scroll = Observable.fromEvent(window, 'scroll').share();


  getViewportHeight() {
    return window.innerHeight;
  }

  getScrollPosition() {
    return Math.max(0, window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0);
  }

  getScrollHeight() {
    return document.body.scrollHeight;
  }

  setScrollHeight(scrollHeight: number) {
    scrollHeight = Math.abs(scrollHeight);
    try {
      document.documentElement.scrollTop = scrollHeight;
      document.body.scrollTop = scrollHeight;
    } catch (err) {
      console.warn(err);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/shared/scroll-container.ts